import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { PageShell } from "@/components/site/PageShell";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Zones } from "@/components/site/Zones";
import { Events } from "@/components/site/Events";
import { Packages, usePackages } from "@/components/site/Packages";
import { Recharge } from "@/components/site/Recharge";
import { Dining } from "@/components/site/Dining";
import { Locations } from "@/components/site/Locations";
import { Enquiry } from "@/components/site/Enquiry";
import { scrollToId } from "@/lib/scroll";

export default function Home() {
  const data = usePackages();
  const [kind, setKind] = useState("birthday");
  const { state } = useLocation();
  useEffect(() => {
    if (!state?.scrollTo) return undefined;
    const t = setTimeout(() => scrollToId(state.scrollTo), 350);
    return () => clearTimeout(t);
  }, [state]);
  return (
    <PageShell testId="home-page">
      <Hero />
      <Marquee />
      <Zones />
      <Events onPick={setKind} />
      <Packages data={data} />
      <Recharge options={data.recharge} />
      <Dining />
      <Locations />
      <Enquiry kind={kind} setKind={setKind} />
    </PageShell>
  );
}
